/**
 * 管理画面用のfetch。認証トークンを自動付与。
 * トークンが失効している(401)場合は、ログイン済みフラグだけが残る「半ログイン」状態
 * (ヘッダー等の骨組みは出るが中身のAPIが全部失敗する)を防ぐため、
 * ログイン情報を消してログイン画面に戻す。
 */
export const adminFetch = async (url, options = {}) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    const separator = url.includes('?') ? '&' : '?';
    url = url + separator + '_token=' + token;
  }
  const res = await fetch(url, options);
  // トークンが最初からない(＝未ログイン状態で呼ばれた)401はリロードしない。
  // ここでリロードすると、未ログイン画面で誤って呼ばれた場合に無限リロードになる。
  if (res.status === 401 && token) {
    localStorage.removeItem('admin_auth');
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_role');
    localStorage.removeItem('admin_email');
    // ハッシュ(#report_customers等)は残す。再ログイン後に同じ画面へ戻れるように。
    window.location.reload();
  }
  return res;
};
